import classNames from 'classnames';
import { DetailedHTMLProps, FC, InputHTMLAttributes, ReactNode, useRef } from 'react';
import styles from './Radio.module.scss';

interface RadioProps extends DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    children?: ReactNode;
    labelClassName?: string;
    rootClassName?: string;
    rootClick?: () => void;
    type?: 'default' | 'button';
}

const Radio: FC<RadioProps> = ({
    children,
    className,
    labelClassName,
    rootClassName,
    type = 'default',
    id,
    rootClick,
    ...props
}) => {
    const inputRef = useRef<HTMLInputElement>(null);

    return (
        <div
            className={classNames('cursor-pointer flex gap-3', styles.warrpperRadio, rootClassName, styles[type], {
                [styles.active]: inputRef.current?.checked
            })}
            onClick={rootClick}
        >
            <input
                ref={inputRef}
                id={id}
                type="radio"
                className={classNames('radio shrink-0', styles.radio, className)}
                {...props}
            />

            <label htmlFor={id} className={classNames('cursor-pointer', labelClassName)}>
                {children}
            </label>
        </div>
    );
};

export default Radio;
